 
import JobBreadcrumb from "../../commonComponents/breadcrumbs/JobBreadcrumb";
import JobDetail from "../../commonComponents/productDetail/JobDetail";

const JobDetail2Container = () => {
  return (
    <>
      <JobBreadcrumb type="style_2" />
      <JobDetail detailType="style_2" />
    </>
  );
};

export default JobDetail2Container;
